'use client';

import { useEffect, useState } from 'react';

export function ClientDate({
  value,
  options,
}: {
  value: string | null;
  options?: Intl.DateTimeFormatOptions;
}) {
  const [text, setText] = useState('—');

  useEffect(() => {
    if (!value) {
      setText('—');
      return;
    }
    setText(new Date(value).toLocaleString('pt-PT', options));
  }, [value]);

  return <span suppressHydrationWarning>{text}</span>;
}
